import React from "react";
import SearchBar from "../SearchBar";
import VanityLinks from "../VanityLinks";
import HomeCoursesCarousel from "../HomeCoursesCarousel";
import "../../../src/Styling/Home.css";
import SliderBar from "../SliderBar";
import HomeCouponCarousel from "../HomeCouponCarousel";
import img1 from "../../Assets/background.gif";


const url = "https://exly.co/oKBEjb";  /* Exly url */ 

/* Stripe url https://buy.stripe.com/3cs03NgKnf4c9CE9AB"; */ 

const Home = () => {
  return (
    <div className="homeComp">
      <img src={img1} alt="loading" className="img1" />
      <button type="button" className="bookbutton" onClick={()=> window.open(url, '_blank')}><h2> Book Hindi Class?  </h2> </button>
      <div className="Home">
        {/* <SearchBar plceholder="type here to search" data={Data} /> */}

        <VanityLinks />

        <HomeCoursesCarousel />
        <SliderBar />
        <HomeCouponCarousel />
        <br />
      </div>
    </div>
  );
};
export default Home;
